










































































import {Component, Emit, Prop, PropSync, Vue} from 'vue-property-decorator'
import * as _ from 'lodash';

import {
  DxDataGrid,
  DxEditing,
  DxRemoteOperations,
  DxFilterRow,
  DxSelection,
  DxLoadPanel,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxPager,
  DxPaging,
  DxSearchPanel,
  DxMasterDetail,
  DxColumnChooser,
  DxColumnFixing,
  DxStateStoring,
  DxSorting,
  DxScrolling,
  DxRowDragging
} from 'devextreme-vue/data-grid';
import { DxColorBox } from "devextreme-vue";
import {DxCheckBox} from "devextreme-vue/check-box";
import AcceptService from "@/services/accept-service";
import ArrayStore from "devextreme/data/array_store";

@Component({
  name: 'AcceptGrid',
  components: {
    DxDataGrid,
    DxEditing,
    DxRemoteOperations,
    DxSelection,
    DxFilterRow,
    DxColumn,
    DxLoadPanel,
    DxGrouping,
    DxGroupPanel,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxMasterDetail,
    DxColumnChooser,
    DxColumnFixing,
    DxStateStoring,
    DxSorting,
    DxScrolling,
    DxColorBox,
    DxRowDragging,
    DxCheckBox,
  }
})
export default class extends Vue {

  @Prop() public dataSource!: any[];
  @Prop() public columns!: any;

  @Prop({default: true}) public isAdmin!: boolean;

  public service = AcceptService;
  public acceptStore: ArrayStore;

  public acceptDataSource: any = {
    store: [],
    reshapeOnPush: true,
  };

  public content_ready: boolean = false;

  created() {
    this.acceptStore = new ArrayStore({
      data: [],
      key: 'id_object',
    });

    this.acceptDataSource.store = this.acceptStore;
  }

  handleCheckboxClick(e: any, cellInfo: any) {
    // шаблон имени столбца "blocks.blocks__ok_hn_blocks__ok"
    const col_name = cellInfo.column.dataField.split('.');
    const row_block = cellInfo.row.data[col_name[0]];

    let data: any = {};
    data[col_name[0]] = {};
    let res_value: any = e.value;

    if (_.isNil(e.previousValue)) {

      res_value = true;
    }
    else if (e.previousValue === true) {

      if (!this.isAdmin && _.isNil(row_block[`${col_name[1]}_init`])) {
 
        res_value = null;
      } else {
      
        res_value = false;
      }

    }
    else if (e.previousValue === false) {
      if (_.isNil(row_block[`${col_name[1]}_init`])) {

        res_value = null;
      } else {

        res_value = true;
      }
    }

    data[col_name[0]][col_name[1]] = -1;

    this.acceptStore.push([{ type: 'update', key: cellInfo.key, data }]);


    this.service.changed = true;

  }

  @Emit('saving')
  onSaving(e: any) {
    return e;
  }

  onRowClick(e: any) {
    debugger
  }
  onCellClick(cellInfo: any) {
   

    if (cellInfo.rowType === 'data') {
      this.changeValue(cellInfo);
    } else if (cellInfo.rowType === 'header') {
      debugger;
    }
  }

  changeValue(cellInfo: any) {
    const col_name = cellInfo.column.dataField.split('.');
    const row_block = cellInfo.row.data[col_name[0]];


    if (_.isNil(cellInfo.value)) {
      cellInfo.setValue(true);
    }
    else if (cellInfo.value === true) {

      if (!this.isAdmin && _.isNil(row_block[`${col_name[1]}_init`])) {
        cellInfo.setValue(null);
      } else {
        cellInfo.setValue(false);
      }

    }
    else if (cellInfo.value === false) {
      if (_.isNil(row_block[`${col_name[1]}_init`])) {
        cellInfo.setValue(null);
      } else {
        cellInfo.setValue(true);
      }
    }

    this.repaint();
    this.$forceUpdate();

    this.service.changed = true;
  }

  loadNewStore(data: any[]) {
    this.content_ready = false;
  
    this.acceptStore = new ArrayStore({
      key: 'id_object',
      data: data,
    });

    this.acceptDataSource.store = this.acceptStore;

    setTimeout(() => {
      this.content_ready = true;

    }, 500);
  }

  @Emit('cell-prepared')
  onCellPrepared(e: any) {
    return e;
  }

  public refresh() {
    const grid = (this.$refs.accept_datagrid as any).instance;
    grid.refresh();
  }

  public repaint() {
    const grid = (this.$refs.accept_datagrid as any).instance;
    grid.repaint();
  }

  public saveEditData() {
    const grid = (this.$refs.accept_datagrid as any).instance;
    grid.saveEditData();
  }

  public navigateToRow(key: any) {
    const grid = (this.$refs.accept_datagrid as any).instance;
    grid.navigateToRow(key);
  }

  public getDxGridInstance(key: any) {
    const grid = (this.$refs.accept_datagrid as any).instance;
    return grid;
  }

  private customizeCell(e: any) {
    if (e.rowType !== 'data' ||
      e.column.dataField.indexOf('blocks__') === -1) {
      return;
    }

    if (_.isNil(e.value)) {
      e.cellElement.classList.add('undefined');
      e.cellElement.innerHTML = '';
    }
    else if (e.value === true) {
      e.cellElement.classList.add('selected');
      e.cellElement.innerHTML = '';
    }
  }
}
